const LABELS = {
    LEASE: 'Lease',
    LEASED_TO_OWN: 'Leased To Own',
    FINANCED: 'Financed',
    PAID_OFF: 'Paid Off',
};

export const PURCHASE_TYPE_OPTIONS = [
    { value: '', label: '—' },
    { value: 'LEASE', label: 'Lease' },
    { value: 'LEASED_TO_OWN', label: 'Leased To Own' },
    { value: 'FINANCED', label: 'Financed' },
    { value: 'PAID_OFF', label: 'Paid Off' },
];

export function purchaseTypeLabel(value) {
    if (!value) return '—';
    return LABELS[value] || value;
}

export function purchaseTypeAddColumn() {
    return {
        label: 'Purchase Type',
        name: 'purchaseType',
        type: 'select',
        dataset: PURCHASE_TYPE_OPTIONS,
        defaultValue: () => '',
        processBeforeSending: (val) => (val ? val : null),
    };
}
